import React from 'react';

import { FormContext, StepContext, RepeatableContext } from './context';

class Step extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {}
    };
    const actions = [];
    let extras = {};

    if (
      RepeatableContext.Consumer._currentValue &&
      RepeatableContext.Consumer._currentValue.abandon
    ) {
      actions.push(RepeatableContext.Consumer._currentValue.abandon);
    }
    if (RepeatableContext.Consumer._currentValue) {
      extras.parent = RepeatableContext.Consumer._currentValue.key;
    }
    FormContext.Consumer._currentValue.add_step({
      ...this.props,
      ...extras,
      actions: [actions],
      getFieldData: () => this.getFieldData(),
      getTitle: () => this.getTitle()
    });

    this.add_step = FormContext.Consumer._currentValue.add_step;
  }

  componentDidUpdate(prevProps) {
    const actions = [];
    let extras = {};

    this.add_step({
      ...this.props,
      ...extras,
      actions: [actions],
      getFieldData: () => this.getFieldData(),
      getTitle: () => this.getTitle()
    });
  }

  getTitle() {
    return this.props.title;
  }

  getFieldData() {
    return this.state.fields;
  }

  render() {
    const { id, skip, nonext, nextText, actions, title, ...props } = this.props;
    let removeFields = [];

    return (
      <div className="step" {...props}>
        <FormContext.Consumer>
          {(formcontext) => (
            <RepeatableContext.Consumer>
              {(repeatablecontext) => (
                <StepContext.Provider
                  value={{
                    validation: formcontext.validation,
                    remove_field: (fieldprops) => {
                      if (
                        !fieldprops ||
                        !fieldprops.id ||
                        !this.state.fields ||
                        this.state.fields.length === 0
                      )
                        return;
                      removeFields.push(fieldprops.id);
                      let fields = {};
                      Object.keys(this.state.fields)
                        .filter((key) => removeFields.indexOf(key) < 0)
                        .forEach((key) => (fields[key] = this.state.fields[key]));
                      this.setState({ fields }, () => {
                        removeFields = removeFields.filter((f) => f === fieldprops.id);
                        // console.log('After', removeFields)
                      });
                    },
                    add_field: (fieldprops) => {
                      this.setState(
                        (state, props) => ({
                          ...state,
                          fields: {
                            ...state.fields,
                            [fieldprops.id]: {
                              label: fieldprops.label,
                              required: fieldprops.required,
                              validation: fieldprops.validation,
                              is_valid: fieldprops.valid
                                ? (data) => {
                                    if (typeof fieldprops.valid === 'function')
                                      return fieldprops.valid(
                                        repeatablecontext
                                          ? data[repeatablecontext.key][repeatablecontext.index]
                                          : data
                                      );
                                    else if (fieldprops.valid.valid)
                                      return fieldprops.valid.valid(
                                        repeatablecontext
                                          ? data[repeatablecontext.key][repeatablecontext.index]
                                          : data
                                      )
                                        ? true
                                        : fieldprops.valid.message;
                                    return true;
                                  }
                                : undefined
                            }
                          }
                        }),
                        () => {
                          formcontext.rerender();
                        }
                      );
                    }
                  }}>
                  {(formcontext.current_step && formcontext.current_step.id === id) ||
                  formcontext.debug
                    ? this.props.children
                    : ''}
                </StepContext.Provider>
              )}
            </RepeatableContext.Consumer>
          )}
        </FormContext.Consumer>
      </div>
    );
  }
}

export default Step;
